import React from 'react';
import { NavLink } from 'react-router-dom';
import { GiFairyWings } from 'react-icons/gi';
import { FaHome } from 'react-icons/fa';
import { Helmet } from "react-helmet-async";
import './PageNotFound.css';

const PageNotFound = () => {
  return (
    <>
    <Helmet>
            <title>Page Not Found | Rajput Shiksha Kosh</title>
            <meta
              name="description"
              content="Page not found for Rajput Shiksha Kosh, informing users about the missing page and providing options to navigate back to the homepage."
            />
          </Helmet> 
    <section className="page-not-found-wrapper">
      <div className="page-not-found-container">
        
        {/* Creative 404 Display */}
        <div className="page-not-found-visual">
          <span className="page-not-found-digit">4</span>
          <div className="page-not-found-icon-box">
            <GiFairyWings className="page-not-found-floating-icon" />
            <div className="page-not-found-shadow"></div>
          </div>
          <span className="page-not-found-digit">4</span>
        </div>

        {/* Theme Divider */}
        <div className="page-not-found-divider">
          <span className="page-not-found-divider-line"></span>
          <GiFairyWings className="page-not-found-divider-icon" />
          <span className="page-not-found-divider-line"></span>
        </div>

        {/* Text Content */}
        <div className="page-not-found-content">
          <h1 className="page-not-found-title">Oops! Page Not Found</h1>
          <p className="page-not-found-description">
            We can't seem to find the page you're looking for. It might have been removed, renamed, or is temporarily unavailable.
          </p>
          
          <NavLink to="/" className="page-not-found-home-btn">
            <FaHome className="page-not-found-btn-icon" />
            Back To Homepage
          </NavLink>
        </div>

      </div>
    </section>
    </>
  );
};

export default PageNotFound;